import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

const TituloFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='TITULO' htmlFor='input-titulo' md={3} alignRightAt='md' />
      <Col md={9}>
        <Field name='titulo'>
          {({ field }) => (
            <Form.InputText
              {...field}
              isInvalid={iTouched && iError}
              disabled={fIsSubmitting}
              id='input-titulo'
            />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(TituloFormGroup)
